import { ReactElement, MouseEvent, useCallback, useRef } from 'react';
import { useLockBodyScroll } from 'react-use';
import ReactDOM from 'react-dom';
import { StyledBackdrop } from './Backdrop.styles';

interface BackdropProps {
  children: React.ReactNode;
  onBackdropClick: (event: React.MouseEvent) => void;
}

export default function Backdrop({ children, onBackdropClick }: BackdropProps): ReactElement {
  const backdrop = useRef<HTMLDivElement>(null);
  const body = useRef(document.body);

  useLockBodyScroll(true, body);

  const backdropClickHandler = useCallback(
    (event: MouseEvent) => {
      event.stopPropagation();
      event.nativeEvent.stopImmediatePropagation();

      if (event.target !== backdrop.current) {
        return;
      }

      onBackdropClick(event);
    },
    [onBackdropClick, backdrop],
  );

  const content = (
    <StyledBackdrop ref={backdrop} onClick={backdropClickHandler}>
      {children}
    </StyledBackdrop>
  );

  // eslint-disable-next-line unicorn/prefer-query-selector
  return ReactDOM.createPortal(content, document.getElementById('modal') as HTMLDivElement);
}
